'use strict';

export default [
    'alert-octagon',
    'alert-circle',
    'activity',
    'alert-triangle',
    'align-center',
    'airplay',
    'align-justify',
    'align-left',
    'align-right',
    'arrow-down-left',
    'arrow-down-right',
    'anchor',
    'aperture',
    'arrow-left',
    'arrow-right',
    'arrow-down',
    'arrow-up-left',
    'arrow-up-right',
    'arrow-up',
    'award',
    'bar-chart',
    'at-sign',
    'bar-chart-2',
    'battery-charging',
    'bell-off',
    'battery',
    'bluetooth',
    'bell',
    'book',
    'briefcase',
    'camera-off',
    'calendar',
    'bookmark',
    'box',
    'camera',
    'check-circle',
    'check',
    'check-square',
    'cast',
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'chevron-up',
    'chevrons-down',
    'chevrons-right',
    'chevrons-up',
    'chevrons-left',
    'circle',
    'clipboard',
    'chrome',
    'clock',
    'cloud-lightning',
    'cloud-drizzle',
    'cloud-rain',
    'cloud-off',
    'codepen',
    'cloud-snow',
    'compass',
    'copy',
    'corner-down-right',
    'corner-down-left',
    'corner-left-down',
    'corner-left-up',
    'corner-up-left',
    'corner-up-right',
    'corner-right-down',
    'corner-right-up',
    'cpu',
    'credit-card',
    'crosshair',
    'disc',
    'delete',
    'download-cloud',
    'download',
    'droplet',
    'edit-2',
    'edit',
    'edit-1',
    'external-link',
    'eye',
    'feather',
    'facebook',
    'file-minus',
    'eye-off',
    'fast-forward',
    'file-text',
    'film',
    'file',
    'file-plus',
    'folder',
    'filter',
    'flag',
    'globe',
    'grid',
    'heart',
    'home',
    'github',
    'image',
    'inbox',
    'layers',
    'info',
    'instagram',
    'layout',
    'link-2',
    'life-buoy',
    'link',
    'log-in',
    'list',
    'lock',
    'log-out',
    'loader',
    'mail',
    'maximize-2',
    'map',
    'map-pin',
    'menu',
    'message-circle',
    'message-square',
    'minimize-2',
    'mic-off',
    'minus-circle',
    'mic',
    'minus-square',
    'minus',
    'moon',
    'monitor',
    'more-vertical',
    'more-horizontal',
    'move',
    'music',
    'navigation-2',
    'navigation',
    'octagon',
    'package',
    'pause-circle',
    'pause',
    'percent',
    'phone-call',
    'phone-forwarded',
    'phone-missed',
    'phone-off',
    'phone-incoming',
    'phone',
    'phone-outgoing',
    'pie-chart',
    'play-circle',
    'play',
    'plus-square',
    'plus-circle',
    'plus',
    'pocket',
    'printer',
    'power',
    'radio',
    'repeat',
    'refresh-ccw',
    'rewind',
    'rotate-ccw',
    'refresh-cw',
    'rotate-cw',
    'save',
    'search',
    'server',
    'scissors',
    'share-2',
    'share',
    'shield',
    'settings',
    'skip-back',
    'shuffle',
    'sidebar',
    'skip-forward',
    'slack',
    'slash',
    'smartphone',
    'square',
    'speaker',
    'star',
    'stop-circle',
    'sun',
    'sunrise',
    'tablet',
    'tag',
    'sunset',
    'target',
    'thermometer',
    'thumbs-up',
    'thumbs-down',
    'toggle-left',
    'toggle-right',
    'trash-2',
    'trash',
    'trending-up',
    'trending-down',
    'triangle',
    'type',
    'twitter',
    'upload',
    'umbrella',
    'upload-cloud',
    'unlock',
    'user-check',
    'user-minus',
    'user-plus',
    'user-x',
    'user',
    'users',
    'video-off',
    'video',
    'voicemail',
    'volume-x',
    'volume-2',
    'volume-1',
    'volume',
    'watch',
    'wifi',
    'x-square',
    'wind',
    'x',
    'x-circle',
    'zap',
    'zoom-in',
    'zoom-out',
    'command',
    'cloud',
    'hash',
    'headphones',
    'underline',
    'italic',
    'bold',
    'crop',
    'help-circle',
    'paperclip',
    'shopping-cart',
    'tv',
    'wifi-off',
    'minimize',
    'maximize',
    'gitlab',
    'sliders',
    'star-on',
    'heart-on',
    'archive',
    'arrow-down-circle',
    'arrow-up-circle',
    'arrow-left-circle',
    'arrow-right-circle',
    'bar-chart-line-',
    'bar-chart-line',
    'book-open',
    'code',
    'database',
    'dollar-sign',
    'folder-plus',
    'gift',
    'folder-minus',
    'git-commit',
    'git-branch',
    'git-pull-request',
    'git-merge',
    'linkedin',
    'hard-drive',
    'more-vertical-',
    'more-horizontal-',
    'rss',
    'send',
    'shield-off',
    'shopping-bag',
    'terminal',
    'truck',
    'zap-off',
    'youtube',
];
